import { Alert, Flex, Input, Modal, Typography } from 'antd'
import { useState } from 'react'

const { Text } = Typography

type ConfirmActionModalProps = {
  open: boolean
  title: string
  description: string
  confirmText: string
  confirmPlaceholder?: string
  warningMessage?: string
  danger?: boolean
  confirmButtonText: string
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const ConfirmActionModal = ({
  open,
  title,
  description,
  confirmText,
  confirmPlaceholder,
  warningMessage,
  danger = true,
  confirmButtonText,
  loading,
  onConfirm,
  onCancel
}: ConfirmActionModalProps) => {
  const [inputValue, setInputValue] = useState('')

  const handleCancel = () => {
    setInputValue('')
    onCancel()
  }

  const handleConfirm = () => {
    onConfirm()
    setInputValue('')
  }

  return (
    <Modal
      open={open}
      title={title}
      okText={confirmButtonText}
      okButtonProps={{ danger, disabled: inputValue !== confirmText }}
      confirmLoading={loading}
      onOk={handleConfirm}
      onCancel={handleCancel}
      destroyOnHidden
    >
      <Flex vertical gap={16} style={{ paddingTop: 8 }}>
        <Text>{description}</Text>
        {warningMessage ? (
          <Alert type="warning" title={warningMessage} showIcon />
        ) : null}
        <div>
          <Input
            placeholder={confirmPlaceholder}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        </div>
      </Flex>
    </Modal>
  )
}
